(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chrome-announcements"] && !Shopify.designMode) return;
  try {
    
  class HarperAnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.viewport = this.querySelector('[data-marquee-viewport]');
      this.track = this.querySelector('[data-marquee-track]');
      this.group = this.querySelector('[data-marquee-group]');
      this.source = this.querySelector('[data-marquee-source]');
      if (!this.viewport || !this.track || !this.group || !this.source) return;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.build());
      };
      this.resize = new ResizeObserver(schedule);
      this.resize.observe(this.viewport);
      this.resize.observe(this.source);
      this.motion.addEventListener('change', schedule, { signal });
      document.addEventListener('visibilitychange', () => this.toggleAttribute('data-page-hidden', document.hidden), { signal });
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.source.contains(event.target)) return;
        this.setAttribute('data-editing', '');
        event.target.scrollIntoView({ block: 'nearest', inline: 'center' });
      }, { signal });
      document.addEventListener('shopify:block:deselect', () => this.removeAttribute('data-editing'), { signal });
      this.intersection = new IntersectionObserver(([entry]) => this.toggleAttribute('data-offscreen', !entry.isIntersecting));
      this.intersection.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) schedule(); });
      schedule();
    }

    copy(element) {
      const clone = element.cloneNode(true);
      clone.removeAttribute('data-marquee-source');
      clone.setAttribute('data-marquee-copy', '');
      clone.setAttribute('aria-hidden', 'true');
      for (const node of [clone, ...clone.querySelectorAll('*')]) {
        node.removeAttribute('data-marquee-source');
        node.removeAttribute('data-marquee-group');
        node.removeAttribute('id');
        node.removeAttribute('data-shopify-editor-block');
        if (node.matches('a, button, input, select, textarea, [tabindex]')) node.setAttribute('tabindex', '-1');
      }
      return clone;
    }

    build() {
      if (!this.isConnected) return;
      this.removeAttribute('data-ready');
      this.track.querySelectorAll('[data-marquee-copy]').forEach((copy) => copy.remove());
      const width = this.source.getBoundingClientRect().width;
      const viewportWidth = this.viewport.clientWidth;
      if (!width || !viewportWidth || this.motion.matches) return;
      const repeatCount = Math.ceil(viewportWidth / width);
      for (let i = 1; i < repeatCount; i++) this.group.append(this.copy(this.source));
      const distance = this.group.getBoundingClientRect().width;
      this.track.append(this.copy(this.group));
      this.style.setProperty('--marquee-distance', `${distance}px`);
      this.style.setProperty('--marquee-duration', `${distance / (Number(this.dataset.speed) || 50)}s`);
      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.resize?.disconnect();
      this.intersection?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  }

  if (!customElements.get('harper-announcement-marquee')) {
    customElements.define('harper-announcement-marquee', HarperAnnouncementMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
